"use client"

import { GetPageQuery } from "apollo"
import { LayoutContext } from "contexts/LayoutProvider"
import { getStockData, GetStockDataResponse } from "lib/api"
import { getStats, StatsType } from "lib/utils"
import { useContext, useEffect, useState } from "react"
import CustomBreadcrumbs from "ui/CustomBreadcrumbs"
import MainContainer from "ui/MainContainer"
import { HomeIcon } from "ui/icons"
import { BlockRenderer } from "utils"
import { findProperty } from "utils/findProperty"
import FinancialReports from "./FinancialReports"
import HeroWrapper from "./HeroWrapper"
import Information from "./Information"
import Parallax from "./Parallax"

const components = {
  investorsHeader: HeroWrapper,
  topBanner: Parallax,
  contentText: Information,
  financialReportsMain: FinancialReports,
}

type Props = {
  data: GetPageQuery
  stockData?: GetStockDataResponse
  financialStats?: StatsType
  locale: string
  maxStockData?: GetStockDataResponse
}

function Investors({ data, stockData, locale, financialStats, maxStockData }: Props) {
  const [updatedStockData, setUpdatedStockData] = useState<GetStockDataResponse | undefined>(
    stockData
  )
  const [updatedFinancialStats, setUpdatedFinancialStats] = useState<StatsType | undefined>(
    financialStats
  )
  const [updatedMaxData, setUpdatedMaxData] = useState<GetStockDataResponse | undefined>(maxStockData)
  const { API_URL } = useContext(LayoutContext)
  useEffect(() => {
    const fetchStockData = async () => {
      const stockDataPromise = getStockData("Days_1")
      const maxDataPromise = getStockData("Days_5")
      const financialDataPromise = getStockData()
      const [stockResponse, maxResponse, financialData] = await Promise.all([
        stockDataPromise,
        maxDataPromise,
        financialDataPromise,
      ])
      setUpdatedStockData(stockResponse)
      setUpdatedFinancialStats(getStats(financialData))
      setUpdatedMaxData(maxResponse)
    }
    fetchStockData()
  }, [API_URL])

  return (
    <>
      <MainContainer rightGap={220}>
        <CustomBreadcrumbs
          locale={locale}
          current={{
            title: locale === "en" ? "Investors Relations" : "קשרי משקיעים",
            url: `/`,
          }}
          parents={[{ title: <HomeIcon />, url: "/" }]}
        />
      </MainContainer>
      {findProperty(data.page, "blocks")?.blocks?.map(
        (block: any, index: number) => (
          <BlockRenderer
            key={index}
            blockType={block.blockType}
            blockData={block}
            props={{ stockData: updatedStockData, maxStockData: updatedMaxData, locale, financialStats: updatedFinancialStats }}
            components={components}
          ></BlockRenderer>
        ),
      )}
    </>
  )
}

export default Investors
